import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import IInitialDetails from '@sunbit-dev/common/models/cardApply/IInitialDetails';
import { ActionTypes, Actions } from '../actions/initialDetailsActions';
import IDocument from '@sunbit-dev/common/models/IDocument';

export interface IInitialDetailsState extends Partial<IInitialDetails> {
  type?: ActionTypes;
  status?: ActionStatus;
  invitationPinCodeDocument?: IDocument;
}

const initialState: IInitialDetailsState = {
}

export default function initialDetailsReducer(state = initialState, action: Actions): IInitialDetailsState {
  switch(action.type) {
    case ActionTypes.getInitialDetails:
      return {...state, ...action};
    default:
      return state;
  }
}
